import type { ReactNode } from 'react';

import { useAuth } from '@shared/common/providers/AuthProvider';
import { getChainNameById } from '@shared/helpers/web3/chain';

import { useSwitchChain } from '../chain/useSwitchChain';
import { ConnectWalletButton } from './ConnectWalletButton';
import { SwitchChainButton } from './SwitchChainButton';

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
  requiredChainId?: number;
  switchChainFallback?: ({
    chainName,
    chainId,
  }: {
    chainName: string;
    chainId: number;
  }) => ReactNode;
};

export const ConnectWalletGuard = ({
  children,
  fallback,
  requiredChainId,
  switchChainFallback,
}: Props) => {
  const { userEvmWallet, isLoading } = useAuth();
  const { activeChain } = useSwitchChain();

  if (!userEvmWallet) {
    return (
      fallback ?? (
        <ConnectWalletButton onConnectSwitchToChainId={requiredChainId} isDisabled={isLoading} />
      )
    );
  }

  const chainName = getChainNameById(requiredChainId);

  if (requiredChainId && requiredChainId !== activeChain) {
    return switchChainFallback ? (
      switchChainFallback({ chainName, chainId: requiredChainId })
    ) : (
      <SwitchChainButton destChainId={requiredChainId} />
    );
  }

  return children;
};
